import type {SocialLink} from '../../marketing-footer.types'

import {SocialIcon} from './social-icons'
import styles from './SocialLinks.module.css'

type Props = {
  socialLinks: SocialLink[]
}

export function SocialLinks({socialLinks}: Props) {
  return (
    <ul className={styles.list}>
      {socialLinks.map(link => (
        <li key={link.iconName}>
          <a
            href={link.url}
            className={styles.iconLink}
            data-analytics-event={JSON.stringify({
              category: 'Footer',
              action: link.analyticsAction,
              label: link.analyticsLabel,
            })}
          >
            <SocialIcon name={link.iconName} className={styles.icon} />
            <span className="visually-hidden">{link.srLabel}</span>
          </a>
        </li>
      ))}
    </ul>
  )
}
